const GIFT_CODE_COMPACT_LENGTH = 10;

/** Normalise un code cadeau saisi à la main (espaces, minuscules, sans tirets). */
export function normalizeGiftCode(raw: string): string {
  const compact = String(raw || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  if (!compact) return '';
  return compact.match(/.{1,4}/g)?.join('-') ?? compact;
}

/** Codes générés : 10 caractères (ABCD-EFGH-IJ). */
export function isCompleteGiftCode(raw: string): boolean {
  const compact = String(raw || '').replace(/[^A-Za-z0-9]/g, '');
  return compact.length === GIFT_CODE_COMPACT_LENGTH;
}

export function isAlreadyRedeemedGiftError(message?: string | null): boolean {
  const text = String(message || '');
  return /déjà (été )?utilis/i.test(text) || /already (been )?used/i.test(text);
}

export function isWrongAccountGiftError(message?: string | null): boolean {
  const text = String(message || '');
  return (
    /autre compte|another account|anderen konto|ander account|otra cuenta|altro account/i.test(
      text
    )
  );
}

const PENDING_GIFT_CODE_KEY = 'rintintin.pendingGiftCode';

export function stashPendingGiftCode(raw: string): string {
  const code = normalizeGiftCode(raw);
  if (typeof sessionStorage === 'undefined') return code;
  if (code) sessionStorage.setItem(PENDING_GIFT_CODE_KEY, code);
  else sessionStorage.removeItem(PENDING_GIFT_CODE_KEY);
  return code;
}

export function peekPendingGiftCode(): string {
  if (typeof sessionStorage === 'undefined') return '';
  return normalizeGiftCode(sessionStorage.getItem(PENDING_GIFT_CODE_KEY) || '');
}

export function clearPendingGiftCode(): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(PENDING_GIFT_CODE_KEY);
}

export function takePendingGiftCode(): string {
  const code = peekPendingGiftCode();
  clearPendingGiftCode();
  return code;
}

